import { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../config/api';
import logService from '../services/logService';
import WholesalerPayments from './WholesalerPayments';
import './MobileToptancilar.css';

// iOS admin uygulamasının WebView'da açtığı Toptancılar ekranı: /mobile/toptancilar
// Web'deki WholesalerPayments'ın kendisi (aynı hesaplar, aynı modallar) mobileApp modunda çizilir;
// ana görünüm WholesalerMobileHome, modallar telefona göre MobileToptancilar.css ile düzenlenir.
// Oturum token'ı iOS'tan gelir (window.__akikAuthToken → utils/apiAuth.js); kullanıcı bilgisi
// log kayıtları (created_by) için /auth/verify'dan alınır. index.js bu yolu App olmadan render eder.
function MobileToptancilar() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('mtp-html');
    document.title = 'Toptancılar';
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
    return () => root.classList.remove('mtp-html');
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/auth/verify`)
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (cancelled || !data?.user) return;
        setUser(data.user);
        logService.setContext(data.user, null);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <MemoryRouter>
      <div className="mtp-page">
        <WholesalerPayments user={user} selectedStore={null} mobileApp />
      </div>
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar
        newestOnTop
        closeOnClick
        draggable
        pauseOnFocusLoss={false}
        theme="colored"
        limit={2}
      />
    </MemoryRouter>
  );
}

export default MobileToptancilar;
